<template>
  <!--  直接引入 外部用v-if控制-->
  <a-modal
    :width="720"
    v-model:visible="visible"
    title="引擎上线"
    @cancel="cancel"
    @ok="ok"
    centered
    okText="前往TwinsMT文本翻译"
    cancelText="前往云译客个人翻译"
  >
    <div class="engineOnline">
      <div class="title">
        <b>您的引擎{{ engineDetail.twinslatorName }}已成功上线！</b>
        <div>可在TwinsMT和云译客中使用</div>
      </div>
      <div class="content">
        <div>
          <img :src="engineDetail.headImageUrl" />
        </div>
      </div>
      <div class="footer"></div>
    </div>
  </a-modal>
</template>

<script>
  import { watch, nextTick, ref, reactive, toRefs, onMounted } from 'vue'
  import { useRouter, useRoute } from 'vue-router'
  export default {
    props: {
      engineDetail: {
        type: Object,
        default: {},
      },
    },
    setup(props, ctx) {
      const state = reactive({
        visible: true,
        //轮询计时器
        timer: null,
        engineDetail: {},
      })
      const router = useRouter()
      const route = useRoute()

      const routerReplace = () => {
        let obj = { ...route.query }
        delete obj.isCreate
        let str = ``
        let keyArr = Object.keys(obj)
        for (let key in obj) {
          if (keyArr[keyArr.length - 1] == key) {
            str += `${key}=${obj[key]}`
          } else {
            str += `${key}=${obj[key]}&`
          }
        }
        router.replace(`./detail?${str}`)
      }

      const ok = () => {
        routerReplace()
        window.open(
          `/experience?type=docTranslate&sourceLangId=${state.engineDetail.sourceLangId}&targetLangId=${state.engineDetail.targetLangId}&twinslatorId=${state.engineDetail.twinslatorId}`
        )
        ctx.emit('update:onlineVisible', false)
      }

      const cancel = (e) => {
        if (e.target.innerText == '前往云译客个人翻译') {
          window.open(
            `/go/pe_pc_login/pe?redirect=translation&enterpriseId=personal`
          )
        }
        ctx.emit('update:onlineVisible', false)
        routerReplace()
      }

      onMounted(() => {
        state.engineDetail = { ...props.engineDetail }
      })

      return {
        ok,
        cancel,
        ...toRefs(state),
      }
    },
  }
</script>

<style scoped lang="less">
  .engineOnline {
    .title {
      text-align: center;
      color: #333;
      margin-bottom: 20px;
      b {
        font-size: 18px;
      }
      div {
        margin-top: 10px;
        font-size: 14px;
      }
    }
    .content {
      text-align: center;
      img {
        width: 640px;
        height: 224px;
      }
    }
  }
</style>
